import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function ErrorLargeIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'Grey6', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M10.463 16.593L10.19 3h3.646l-.272 13.593h-3.102zm1.55 1.648c.563 0 1.035.18 1.416.54.38.361.571.808.571 1.34s-.19.978-.571 1.338c-.381.36-.853.541-1.415.541-.563 0-1.043-.18-1.443-.54A1.769 1.769 0 0110 20.12c0-.532.19-.978.571-1.338.4-.36.88-.54 1.443-.54z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=ErrorLarge.js.map